var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteBook = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.977 5h-.002a.936.936 0 0 0-.926.937v14.047c0 .515.418.935.932.936 2.166.006 5.794.46 8.297 3.097v-14.7a.902.902 0 0 0-.128-.475C12.096 5.512 8.148 5.005 5.977 5zM24.95 19.984V5.937A.936.936 0 0 0 24.026 5h-.002c-2.17.005-6.118.511-8.173 3.842a.902.902 0 0 0-.128.475v14.7c2.503-2.637 6.132-3.092 8.297-3.097a.937.937 0 0 0 .932-.936z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.07 8.24h-.675v11.744a2.389 2.389 0 0 1-2.372 2.39c-1.837.005-4.866.367-7.011 2.41 3.71-.914 7.62-.32 9.85.192A.934.934 0 0 0 28 24.063V9.176a.935.935 0 0 0-.93-.936zM3.605 19.984V8.24H2.93c-.513 0-.93.42-.93.936v14.887a.934.934 0 0 0 1.138.913c2.23-.512 6.14-1.106 9.85-.191-2.145-2.044-5.174-2.406-7.01-2.41a2.388 2.388 0 0 1-2.373-2.391z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-book.0718ab10eb5c7f1ad9668b94d2b20379.svg";